import React, {useEffect, useState} from 'react';
import styles from './PlatformsUsageWidget.module.scss';
import {useDispatch, useSelector} from "react-redux";
import api from "helpers/api";
import _ from "lodash";
import PlatformCard from "components/miscellaneous/PlatformCard/PlatformCard";
import AliceCarousel from "react-alice-carousel";
import 'react-alice-carousel/lib/alice-carousel.css';
import Loader from "components/miscellaneous/Loader/Loader";
import PlatformUsagePieChart from "components/PlatformUsagePieChart/PlatformUsagePieChart";
import { $t } from 'helpers/translator';
import Tooltip from 'components/miscellaneous/Tooltip/Tooltip';
import moment from 'moment';

const PlatformsUsageWidget = ({dateRange}) => {
    const { startDate, endDate } = dateRange;
    const dispatch = useDispatch();
    const [platforms, setPlatforms] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [usage, setUsage] = useState(null);

    useEffect(async () => {
        setIsLoading(true);
        await getData();
    }, [dateRange])

    const getStatHours = (usage, stat) => {
        let times = usage?.time;
  
        if(times) {
            if(times[stat]) {
                const hours = times[stat] / 60 / 60;
                if(hours > 1) {
                    if(hours < 10000) {
                        const hoursTranslation = $t('global.dateTime.hours');
                        return hours.toFixed(2) + ' ' + hoursTranslation;
                    } else {
                        const days = hours / 24;
                        const daysTranslation = $t('global.dateTime.days');
                        return days.toFixed(2) + ' ' + daysTranslation;
                    }
                } else {
                    const minutes = times[stat] / 60;
                    if(minutes > 0) {
                        const minutesTranslation = $t('global.dateTime.minutes');
                        return minutes.toFixed(2) + ' ' + minutesTranslation;
                    } else {
                        return $t('global.machines.pieChart.noActivity')
                    }
                }
            } else {
                return $t('global.machines.pieChart.noActivity')
            }
        }
    }

    const getTranslation = (key) => {
        const t = $t(`global.machines.pieChart.${key}`);
        return t.split('/')[0].split(' + ')[0];
    }

    async function getData() {
        try {
            let payload = {
                sort: 'created_at',
                order: 'asc',   // or desc
                search: '',
                clinic: '',   // or id
                page: 1,
                per_page: 100,
                usage: true,
                detached: false
            };
            let platformsRes = await api.get(`platform?sort=${payload.sort}&order=${payload.order}&clinic=${payload.clinic}&search=${payload.search}&page=${payload.page}&per_page=${payload.per_page}&get_usage=${payload.usage}&detached=${payload.detached}&start_date=${startDate}&end_date=${endDate}`);
            //console.log(platformsRes)
            if (platformsRes && platformsRes.success) {
                let platformCards = [];

                _.forEach(platformsRes.data.data.data, (platform, k) => {
                    const lastConnected = platform.last_connected_at ? platform.last_connected_at : platform.last_connected;
                    // console.log(v)
                    platformCards.push(
                        <div className={styles.cardContainer} key={k}>
                            <div className={styles.topPart}>
                                <div>
                                    <div className={styles.name}>{platform.machine_name}</div>
                                    <div className={styles.id}>{platform.machine_id}</div>
                                </div>
                                <div className={styles.dateAdded} style={{marginLeft: 'auto'}}>
                                    {lastConnected ? <>Last active {moment(lastConnected).fromNow()}</> : <>Not Active</>}
                                </div>
                            </div>
                            <div className='d-flex align-items-center'>
                                <div className={styles.platformImg}><img src={platform.image} width={155} alt={platform.machine_type}/></div>
                                <div className={styles.usageContainer}>
                                    <div className='d-flex align-items-center'>
                                        <div className={styles.usageData}>
                                            <div>
                                                <span>{getTranslation('online')}</span>
                                                <h3 style={{color: '#473073'}}>{getStatHours(platform.usage, 'online')}</h3>
                                            </div>
                                            <div>
                                                <span>{getTranslation('treatment')}</span>
                                                <h3 style={{color: '#319aa1'}}>{getStatHours(platform.usage, 'treatment')}</h3>
                                            </div>
                                            <div>
                                                <span>{getTranslation('lasing')}</span>
                                                <h3 style={{color: '#f7c59f'}}>{getStatHours(platform.usage, 'lasing')}</h3>
                                            </div>

                                        </div>
                                        <div className={styles.usageGraph}>
                                            <PlatformUsagePieChart size={175} data={{
                                                lasing: platform.usage.percentage.lasing,
                                                treatment: platform.usage.percentage.treatment,
                                                online: platform.usage.percentage.online,
                                            }}/>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    )
                })

                setPlatforms(platformCards);
            }

        } catch (e) {
            console.error('err getting platforms', e)
        } finally {
            setIsLoading(false);
        }
    }

    return (
        <div className={styles.content}>
            {!isLoading ? <div className={styles.platformsContainer}>
                <AliceCarousel
                    mouseTracking
                    items={platforms}
                    responsive={{
                        0: {items: 1},
                    }}
                    autoWidth={false}
                    disableButtonsControls={false}
                    disableDotsControls={true}
                    keyboardNavigation={true}
                />
            </div> : <div style={ { margin: 'auto' } }><Loader color="#ddd"></Loader></div>}
        </div>
    );
}


export default PlatformsUsageWidget;
